<div *ngFor="let i of Ids" class="p-10">
  <button mat-flat-button color="primary" (click)="onClick(i)">
    <mat-icon>done</mat-icon> Remove>
  </button>
</div>
